import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var InLineMath = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M42.54 13.16c-1.816-1.929-5.219-1.929-7.034 0L19.284 29.38c-.226-.113-.34-.227-.68-.227H1.134c-.567 0-1.134.568-1.134 1.248 0 .681.454 1.248 1.134 1.248h15.882c-.227.227-1.021 1.248-1.021 1.248l-2.382 8.054c-.114.34-.114.68.113.908.227.226.68.34 1.02.34l8.282-2.496c.227 0 .34-.113.454-.227l19.17-19.17a5.251 5.251 0 0 0-.113-7.147ZM15.653 40.158l1.702-5.559 3.857 3.857-5.559 1.702Zm7.147-2.61-4.651-4.65 15.541-15.541 4.651 4.65L22.801 37.55Zm18.49-18.49-1.815 1.816-4.65-4.651 1.814-1.815c1.248-1.248 3.404-1.248 4.651 0 1.248 1.247 1.248 3.403 0 4.65Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35.394c0-.681.68-1.248 1.475-1.248h8.508c2.041 0 2.041 2.382 0 2.382H1.475C.68 36.641 0 36.074 0 35.394ZM25.297 4.652l-.568.567c-1.134 1.135-2.835-.567-1.701-1.701l.567-.568c3.744-3.516 8.962 1.815 5.445 5.445l-2.496 2.496h2.95c1.588 0 1.588 2.382 0 2.382h-5.445c-1.135 0-1.929-1.361-1.021-2.382l4.197-4.197c1.475-1.361-.567-3.403-1.928-2.042Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M18.604 23.256a.89.89 0 0 1 0 1.248.89.89 0 0 1-1.248 0l-6.58-6.807-6.579 6.807a.89.89 0 0 1-1.248 0 .89.89 0 0 1 0-1.248l6.58-6.806-6.58-6.807a.89.89 0 0 1 0-1.248.89.89 0 0 1 1.248 0l6.58 6.807 6.579-6.807a.89.89 0 0 1 1.248 0 .89.89 0 0 1 0 1.248l-6.58 6.806 6.58 6.807Z"
  }));
});
InLineMath.displayName = 'InLineMath';
InLineMath.defaultProps = {
  'aria-label': 'InLineMath'
};
export default InLineMath;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/InLineMath.js
// module id = 3549
// module chunks = 11